import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled/stack';
import { ListItemSkeleton } from '@atlassian/home-list-ui/skeleton';

export const LoadingState = (): React.ReactNode => (
	<Stack>
		<ListItemSkeleton />
		<ListItemSkeleton />
		<ListItemSkeleton />
		<ListItemSkeleton />
		<ListItemSkeleton />
	</Stack>
);
